export class IntegrationsService {
    objectsDifferentKeys(primary, secondary) {
        return Object.keys(primary).filter((key) => {
            return primary[key] != secondary[key];
        });
    }
}
